import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/lib/auth";

const AdminLoginPage = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-arel-bg p-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <img src="/assets/logo/arel-logo.png" alt="AREL Nepal" className="h-14 w-auto" />
        </div>

        <div className="arel-card rounded-2xl p-8">
          <div className="mb-2 flex items-center gap-2 text-[#dd0447]">
            <Lock className="h-4 w-4" />
            <span className="overline">Admin Access</span>
          </div>
          <h1 className="font-display text-3xl font-black text-ink">Sign in to dashboard</h1>
          <p className="mt-2 text-sm text-muted-warm">
            Use your admin credentials to manage products and inquiries.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="mb-2 block text-xs font-semibold uppercase tracking-widest text-muted-warm">
                Email
              </label>
              <input
                data-testid="admin-login-email"
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="arel-input w-full rounded-md px-4 py-3 text-sm"
                placeholder="admin@arelnepal.com"
              />
            </div>
            <div>
              <label className="mb-2 block text-xs font-semibold uppercase tracking-widest text-muted-warm">
                Password
              </label>
              <input
                data-testid="admin-login-password"
                type="password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="arel-input w-full rounded-md px-4 py-3 text-sm"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="arel-primary-btn inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold disabled:opacity-60"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" />}
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
